import { QuickQuoteRequest, QuickQuoteResponse } from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'quick-quote';

export class QuickQuoteController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async getRates(request: QuickQuoteRequest): Promise<QuickQuoteResponse> {
    const response = await this.http.post<QuickQuoteResponse>('rate', {
      request,
    });
    return new QuickQuoteResponse(response.data);
  }
}
